export default WebSocket;
